import { z } from "zod";

export const ClientesSchema = z.object({
    idCliente: z.number().int().optional(),
    nomeFantasia: z.string().nonempty({ message: "Nome Fantasia é obrigatório" }),
    dataCadastro: z.coerce.date().default(new Date()),
    razaoSocial: z.string().optional().nullable(),
    cnpj: z.string().optional().nullable(),
    cpf: z.string().optional().nullable(),
    incricaoEstadual: z.string().optional().nullable(),
    incricaoMunicipal: z.string().optional().nullable(),
    atividade: z.string().optional().nullable(),
    obsCliente: z.string().optional().nullable(),
    idEndereco: z.number().int().optional().nullable(),
    telefoneFixo: z.string().optional().nullable(),
    telefoneCelular: z.string().optional().nullable(),
    email: z.string().optional().nullable(),
    contato: z.string().optional().nullable(),
    unidade: z.string().optional().nullable(),
    dataNascimento: z.coerce.date().optional().nullable(),
    nomeFantasia2: z.string().optional().nullable(),
    cpf2: z.string().optional().nullable(),
    dataNascimento2: z.coerce.date().optional().nullable(),

    // endereco 
    rua: z.string().optional().nullable(),
    numero: z.string().optional().nullable(),
    apartamento: z.string().optional().nullable(),
    cep: z.string().optional().nullable(),
    uf: z.string().optional().nullable(),
    cidade: z.string().optional().nullable(),
    bairro: z.string().optional().nullable(),
    pais: z.string().optional().nullable(),
});

export type ClientesForm = z.infer<typeof ClientesSchema>;

export const defaultClientesForm: Partial<ClientesForm> = {
    idCliente: 0,
    dataCadastro: new Date(),
    razaoSocial: null,
    nomeFantasia: '',
    cnpj: null,
    cpf: null,
    incricaoEstadual: null,
    incricaoMunicipal: null,
    atividade: null,
    obsCliente: null,
    idEndereco: null,
    telefoneFixo: null,
    telefoneCelular: null,
    email: null,
    contato: null,
    unidade: null,
    dataNascimento: null,
    nomeFantasia2: null,
    cpf2: null,
    dataNascimento2: null,

    // endereco
    rua: null,
    numero: null,
    apartamento: null,
    cep: null,
    uf: null,
    cidade: null,
    bairro: null,
    pais: null,

};
